import { render, staticRenderFns } from "./CMSPageShow.vue?vue&type=template&id=4f07927e&"
import script from "./CMSPageShow.vue?vue&type=script&lang=js&"
export * from "./CMSPageShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports